__turbopack_context__.v({
  "className": "instrument_serif_c370b470-module__COGrwa__className",
});
